import { getPrivateApi } from "../lib/axiosConfig";
import { Receipt, TotemOrder, TotemTransaction, TransactionError, TransactionReturn, VacuumActivation, VacuumOption } from "../types/vacuum.types";
import { AppError } from "./classes";
import { retry } from "./generic";

const api = getPrivateApi();
const endpoint = "/vacuum-cleaners";

export const getVacuumCleanersByStation = async (station: string):Promise<VacuumOption[]> => {
  try {
    const { data } = await api.get(`${endpoint}/station/${station}`);
    return data;
  } catch (error: any) {
    const errMsg = "Falha ao buscar aspiradores da estação";

    console.error(errMsg, error?.response ?? error);

    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
};

export const getAllVacuumCleaners = async ():Promise<VacuumOption[]> => {
  try {
    const { data } = await api.get(`${endpoint}`);
    return data;
  } catch (error: any) {
    const errMsg = "Falha ao buscar aspiradores";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  };
};

export const createTotemTransaction = async (payload: TotemTransaction): Promise<TransactionReturn | TransactionError> => {
  const { amount, paymentType, totemId } = payload;

  const normalizedValue = Math.round(Number(amount) * 100).toString()

  try {
    const response = await api.post(
      `/totem/transaction`,
      {
        totemId,
        appType: paymentType,
        amount: normalizedValue,
      }
    );

    console.log('Transação criada com sucesso:', response.data);
    return { success: true, data: response.data };
  } catch (error: any) {
    console.error('Erro ao criar transação:', error?.response?.data || error.message);
    return { success: false, error: error?.response?.data || error.message };
  }
};

export const createTotemOrder = async (payload: TotemOrder) => {
  const { price, time, paymentType, taxId, vacuumCleanerId, totemId, cieloTransactionId } = payload;
  try {
    const response = await api.post(
      `/vacuum-cleaner-orders`,
      {
        price,
        time,
        paymentType,
        taxId,
        vacuumCleanerId,
        totemId,
        cieloTransactionId,
      }
    );
    console.log('Ordem criada com sucesso:', response.data);
  } catch (error: any) {
    console.error('Erro ao criar ordem:', error?.response?.data || error.message);
  }
};

export const sendReceipt = async (receipt: Receipt): Promise<void> => {
  try {
    await retry(() =>
      api.post(`/receipts/send`, receipt), 3, 2000
    );
  } catch (error: any) {
    const errMsg = "Erro ao enviar recibo";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}

export const activateVacuumCleaner = async (payload: VacuumActivation): Promise<void> => {
  try {
    await retry(() =>
      api.post('/vacuumcleaner/publish', payload), 3, 3000
    );
  } catch (error: any) {
    const errMsg = "Erro ao ativar aspirador";

    console.error(errMsg, error?.response?.data || error.message || error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  }
}

export const createVacuumCleaner = async (payload: any): Promise<void> => {
  try {
    await api.post(`${endpoint}`, payload);
  } catch (error: any) {
    const errMsg = "Erro ao criar aspirador";
    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  }
};

export const deleteVacuumCleaner = async (id: string): Promise<void> => {
  try {
    await api.delete(`${endpoint}/${id}`);
  } catch (error: any) {
    const errMsg = "Erro ao deletar aspirador";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  }
};

export const linkDeviceToVacuumCleaner = async (vacuumCleanerId: string, serialNumber?: string): Promise<void> => {
  try {
    await api.put(`${endpoint}/link/${vacuumCleanerId}${serialNumber ? '?serialNumber='+ serialNumber : ''}`);
  } catch (error: any) {
    const errMsg = "Erro ao vincular dispositivo ao aspirador";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  }
};
